import { IGetPublishTermsRequest } from '../../../../../services/publishTerms';

export const isParametersValid = (parameters: IGetPublishTermsRequest) => {
  const { id, category, locationPath } = parameters;

  return (
    // у объявления должна быть категория
    !!category &&
    // у объявления должен быть ID или locationPath
    (!!id || (Array.isArray(locationPath) && locationPath.length > 0))
  );
};
